/**
 * How old a send time may be and still count as "now".
 *
 * ONE number, shared by the two places that judge whether a start has passed:
 * the compose dialog's Send gate (`past-time-gate.ts`) and the recurrence
 * popover's commit (`resolveRecurrenceCommit`). If they used different
 * boundaries there would be a band of starts that Done keeps and Send refuses —
 * or that Send accepts after Done had already moved them. Someone who sets 12:00
 * at 12:00 must be able to press Send, whether or not the message repeats.
 */
export const SCHEDULE_PAST_GRACE_MS = 60_000;
